import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
import { HotelComponent } from '../hotel/hotel.component';

@Component({
  selector: 'app-hotel-list',
  templateUrl: './hotel-list.component.html',
  styleUrls: ['./hotel-list.component.css']
})
export class HotelListComponent implements OnInit {

  public menu_item_id = '89';
  public add_auth;
  public edit_auth;
  public del_auth;

  private dp = [];
  displayedColumns = ['hotel_name', 'country_name', 'city_name', 'edit', 'del'];  // , 'add_room', 'room_price'
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<HotelComponent>;
  @ViewChild(MatSort) sort: MatSort;

  model = { 'table_name': 'hotel', 'hotel_name': '' };

  Success_Msg; Error_Msg; Del_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
  }

  search() {

    let condition = "";

    if (this.model['hotel_name'] != '')
      condition += " (`hotel_name` LIKE '%" + this.model['hotel_name'] +
        "%' OR `hotel_name_en` LIKE '%" + this.model['hotel_name'] + "%') AND ";

    let query = "SELECT `hotel`.*, `city`.`city_name`, `country`.`country_name`,"
      + " `country`.`country_id` FROM `hotel`, `city`,`country` WHERE" + condition
      + " `hotel`.`status` = '1' AND `hotel`.`city_id` = `city`.`city_id` AND"
      + " `country`.`country_id` = `city`.`country_id` AND `country`.`country_id` = `hotel`.`country_id`";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  newHotel() {
    this.addDialogRef = this.dialog.open(HotelComponent, {
      hasBackdrop: false,
      //data: this.dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['status'] == 'success')
          this.search();
      });
  }

  editHotel(row) {
    let dialog_data = {
      'table_name': 'hotel', 'hotel_id': row.hotel_id,
      'hotel_name': row.hotel_name,
      'hotel_name_en': row.hotel_name_en,
      'housing_type': row.housing_type,
      'hotel_type': row.hotel_type,
      'address': row.address,
      'hotel_tel': row.hotel_tel,
      'hotel_email': row.hotel_email,
      'hotel_site': row.hotel_site,
      'responsible': row.responsible,
      'responsible_phone': row.responsible_phone,
      'country_id': row.country_id,
      'city_id': row.city_id,
      'comment': row.comment
    };
    this.addDialogRef = this.dialog.open(HotelComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        this.search();
      });
  }

  delHotel(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'hotel_id': row.hotel_id }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          //console.log(data);
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

}
